import type { IterationsReport } from '../../../../redux/domains/Journeys/JourneysHistory/types';
import type { Rule } from '../../../types/journeyTypes';

export class JourneysHistoryService {
  /**
   * Maps an array of Rule to a report format, initializing certain properties with default values.
   *
   * This method transforms each `Rule` object in the input array into an `IterationReportItem` by adding additional properties
   * (`views`, `clicks`, `installs`, `cti`) with default loading and value states. The `views`, `clicks`, `installs`, and `cti` properties
   * are initialized with `{ loading: true, value: null }`.
   *
   * @param {Rule[]} iterations - An array of `Rule` objects to be mapped to the report format.
   * @returns {IterationsReport} An array of `IterationReportItem` objects, where each `Rule` is transformed with additional properties.
   */
  public static mapIterationsToReport = (iterations: Rule[]): IterationsReport => {
    return iterations.map((iteration: Rule) => ({
      ...iteration,
      last_attributed_touch_data_tilde_journey_customer_version: `${iteration.customer_version}`,
      branch_cta_view: 0,
      click: 0,
      install: 0,
      calculation__click_to_install: '0',
      isDruid: false,
    }));
  };
}
